<template>
    <v-row>
      <v-col cols="12">
          <live-sales-card> </live-sales-card> 
      </v-col>
    </v-row>
  </template>
  <script>
  import LiveSalesCard from "@/components/report/LiveSalesCard";
  
  export default {
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Live Sales",
    },
  
    components: {
        LiveSalesCard
    },
  
    data() {
      return {
      };
    },
  };
  </script>